import { ExternalIntegrationCard } from '../ExternalIntegrationCard/ExternalIntegrationCard'
import { ExternalIntegrationEnum, WixIntegration } from 'api/clients/ExternalIntegrationsClient'
import { Wix } from 'blaze-ui/icons/20'
import { CardButtons } from './CardButtons'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useBlogIntegrations } from 'hooks/useBlogIntegrations'

export const WixCard = ({
  integrations = [],
  canConnect,
  isDisconnected = false,
}: {
  integrations?: WixIntegration[]
  canConnect?: boolean
  isDisconnected?: boolean
}) => {
  const { initiateOauth } = useInitiateOauth()
  const wixEnabled = useFlipperFlag('wix_blog_integration')
  const { getRestrictionMessage } = useBlogIntegrations()

  const restrictionMessage = getRestrictionMessage(ExternalIntegrationEnum.Wix)
  const canConnectWix = canConnect ?? !restrictionMessage

  const handleConnect = () => {
    initiateOauth(ExternalIntegrationEnum.Wix)
  }

  if (!wixEnabled) return null

  return (
    <ExternalIntegrationCard
      title="Wix"
      description="Connect your Wix blog to publish content directly from Blaze"
      integrations={integrations}
      icon={<Wix size={20} />}
      isDisabled={!canConnectWix}
      isDisconnected={isDisconnected}
      buttons={
        <CardButtons
          onConnect={handleConnect}
          provider={ExternalIntegrationEnum.Wix}
          isConnected={integrations.length > 0}
          integration={integrations[0]}
          isDisabled={!canConnectWix}
          tooltipMessage={restrictionMessage || undefined}
          isDisconnected={isDisconnected}
        />
      }
    />
  )
}
